/* eslint-disable camelcase */
import { formatISO } from '@ott/utility-date';
import qs from 'qs';

const HOST = 'https://www.onetwotrip.com';

export default function getHotelPopunderLink({
  startDate,
  endDate,
  adults,
  children,
  children_ages,
  to,
}) {
  const formatedStartDate = formatISO(startDate);
  const formatedEndDate = formatISO(endDate);

  const queryString = qs.stringify({
    date_start: formatedStartDate,
    date_end: formatedEndDate,
    adults,
    children,
    children_ages,
    meta_id: to,
    source: 'railways',
    s: true,
  });

  return `${HOST}/ru/hotels/popunder?${queryString}`;
}
